import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-768a10c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "inline-flex items-center mt-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "¿Tiene Bodega?")
], -1))
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = { class: "inline-flex items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2 mr-4" }, "Si", -1))
const _hoisted_6 = { class: "inline-flex items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "No", -1))
const _hoisted_8 = { class: "flex justify-between mt-4" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Modal, {
      title: "Agregar Residente",
      visible: _ctx.showModal,
      "onUpdate:visible": _cache[10] || (_cache[10] = (e) => _ctx.$emit('update:visible', e))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TextField, {
          label: "Nombre",
          model: _ctx.nombre,
          "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nombre) = $event)),
          type: "text",
          name: "nombre"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Profesion",
          model: _ctx.profesion,
          "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profesion) = $event)),
          type: "text",
          name: "profesion"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Depto",
          model: _ctx.departamento,
          "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.departamento) = $event)),
          type: "text",
          name: "departamento"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Número",
          model: _ctx.numero,
          "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.numero) = $event)),
          type: "number",
          name: "numero"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Estaconamiento",
          model: _ctx.estacionamiento,
          "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.estacionamiento) = $event)),
          type: "text",
          name: "estacionamiento"
        }, null, 8, ["model"]),
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "form-radio",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bodega) = $event)),
                value: "true"
              }, null, 512), [
                [_vModelRadio, _ctx.bodega]
              ]),
              _hoisted_5
            ]),
            _createElementVNode("label", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                class: "form-radio",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bodega) = $event)),
                value: "false"
              }, null, 512), [
                [_vModelRadio, _ctx.bodega]
              ]),
              _hoisted_7
            ])
          ])
        ]),
        _createVNode(_component_TextField, {
          label: "Móvil",
          model: _ctx.movil,
          "onUpdate:model": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.movil) = $event)),
          type: "text",
          name: "movil"
        }, null, 8, ["model"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.showAlert)
            ? (_openBlock(), _createBlock(_component_Alert, {
                key: 0,
                type: _ctx.type,
                message: _ctx.message
              }, null, 8, ["type", "message"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "px-4 py-2 mr-2 rounded-md bg-gray-300 hover:bg-gray-400 focus:bg-gray-400",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancelModal && _ctx.cancelModal(...args)))
          }, "Cancelar"),
          _createElementVNode("button", {
            class: "px-4 py-2 rounded-md bg-primary text-white hover:bg-green-600 focus:bg-green-600",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveResident && _ctx.saveResident(...args))),
            disabled: _ctx.loading
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Agregar"))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_13))
          ], 8, _hoisted_9)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_ModalAlert, {
      message: _ctx.message,
      visible: _ctx.showModalAlert,
      option: true,
      onAccept: _ctx.cancelModal
    }, null, 8, ["message", "visible", "onAccept"])
  ]))
}